export const heures = {
  id: "heures",
  sort: true,
  mobile: true,
  padding: true,
  label: "Heures"
}
